import Image from 'next/image';
import { useTranslation } from 'react-i18next';

import { Flex, Heading, Text, useBreakpointValue } from '@chakra-ui/react';

import { ButtonLink } from '~/components/button-link';
import { trackEvent } from '~/features/analytics/track-event';

import { BriefCaseIcon, UserIcon } from '../icons';

import { HeroLayout } from './hero-layout';

export function HomepageCTASection() {
  const { t } = useTranslation();
  const objectPosition = useBreakpointValue(
    {
      base: '74%',
      md: 'top',
    },
    { fallback: 'md' }
  );
  return (
    <HeroLayout
      backgroundImageOverlayGradient={{
        base: 'linear(90deg,rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0) 90%, rgba(0, 0, 0, 0) 100%)',
        md: 'radial(circle,rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0) 70%, rgb(0, 0, 0) 100%)',
      }}
      backgroundImageSlot={
        <Image
          alt=''
          loading='lazy'
          quality={80}
          sizes='(max-width: 1023px) 1000px, 100vw'
          src='/images/experiments/ab_plp_redesign_2025/it-specialist-in-front-of-computer.png'
          style={{ objectFit: 'cover', objectPosition }}
          fill
        />
      }
      ctaSlot={
        <>
          <ButtonLink
            buttonProps={{
              leftIcon: <UserIcon height='20px' width='20px' />,
              flex: {
                base: 1,
                md: 'unset',
              },
              onClick: () =>
                trackEvent({
                  name: 'Homepage CTA Clicked',
                  type: 'click',
                  label: 'HP_banner_option_clicked',
                  value: 'Individuals',
                }),
            }}
            linkProps={{
              href: '/experience',
            }}
          >
            {t('common.forIndividuals')}
          </ButtonLink>
          <ButtonLink
            buttonProps={{
              leftIcon: <BriefCaseIcon height='20px' width='20px' />,
              variant: 'outline',
              colorScheme: 'white',
              flex: {
                base: 1,
                md: 'unset',
              },
              onClick: () =>
                trackEvent({
                  name: 'Homepage CTA Clicked',
                  type: 'click',
                  label: 'HP_banner_option_clicked',
                  value: 'Businesses',
                }),
            }}
            linkProps={{
              href: '/enterprise/overview',
            }}
          >
            {t('common.forBusinesses')}
          </ButtonLink>
        </>
      }
      minHeight={{
        md: '560px',
      }}
      textContentSlot={
        <Flex
          flexDirection='column'
          gap={8}
          whiteSpace='pre-wrap'
          maxWidth={{
            base: '253px',
            md: '638px',
          }}
        >
          <Heading
            as='h2'
            color='white'
            fontWeight='600'
            lineHeight='1.1'
            fontSize={{
              base: '2.5rem',
              md: '3.375rem',
            }}
          >
            {t('home.cta.title')}
          </Heading>
          <Text color='gray.300' fontSize='lg' lineHeight='lg'>
            {t('home.cta.description')}
          </Text>
        </Flex>
      }
    />
  );
}
